<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs" id="v-step-4"></v-breadcrumbs>
          </v-col>
          <v-col cols="6" class="v-margit_button text-right">
            <v-btn
              color="#1B437C"
              style="z-index:8;"
              id="v-step-0"
              depressed
              dark
              @click=";(dialogAdd = true), validate('ADD')"
            >
              <v-icon left>mdi-text-box-plus</v-icon>
              สร้างกลุ่มเป้าหมาย
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <!-- Add data -->
          <v-dialog v-model="dialogAdd" persistent max-width="50%">
            <v-card class="text-center">
              <v-form ref="form_add" v-model="validAdd" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogAdd = false), clearAdd()"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row class="mb-6" justify="center">
                      <v-col md="auto">
                        <v-img
                          class="v_text_add"
                          :src="require('@/assets/Grouptitle.png')"
                        ></v-img>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="4" class="text-center">
                        <v-card elevation="2" class="mx-auto">
                          <v-container>
                            <v-card-title>เป้าหมายโดยประมาณ</v-card-title>
                            <v-card-text>
                              <v-progress-circular
                                :rotate="360"
                                :size="100"
                                :width="15"
                                :value="valueAdd"
                                color="teal"
                              >
                                {{ valueAdd }} %
                              </v-progress-circular>
                            </v-card-text>
                            <v-card-text>จำนวน {{ dataAdd }} คน</v-card-text>
                          </v-container>
                        </v-card>
                        <div class="text-center">
                          <v-btn
                            color="blue-grey"
                            class="ma-2 white--text"
                            @click="getDataAdd()"
                          >
                            Update
                            <v-icon right dark>
                              mdi-cloud-upload
                            </v-icon>
                          </v-btn>
                        </div>
                      </v-col>
                    <!-- {{formAdd}} -->
                      <v-col cols="8" class="text-center">
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="12">
                              <v-row style="height: 65px">
                                <v-text-field
                                  label="ชื่อกลุ่มเป้าหมาย"
                                  v-model="formAdd.audiencesName"
                                  :rules="[rules.required]"
                                  dense
                                  outlined
                                  required
                                ></v-text-field>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-select
                                  :items="dataLevel"
                                  v-model="formAdd.audiencesLevel"
                                  dense
                                  outlined
                                  label="ระดับสมาชิก"
                                ></v-select>
                              </v-row>
                            </v-col>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-select
                                  :items="dataGender"
                                  v-model="formAdd.audiencesGender"
                                  dense
                                  outlined
                                  label="เพศ"
                                ></v-select>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-text-field
                                   v-model="formAdd.audiencesCoinStart"
                                  label="เหรียญขั้นต่ำ"
                                  dense
                                  outlined
                                  type="number"
                                  min="0"
                                ></v-text-field>
                              </v-row>
                            </v-col>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-text-field
                                   v-model="formAdd.audiencesCoinEnd"
                                  dense
                                  outlined
                                  label="เหรียญไม่เกิน"
                                  required
                                  type="number"
                                  min="0"
                                ></v-text-field>
                              </v-row>
                            </v-col>
                            <!-- <v-col cols="2">
                              <v-btn
                                class="mx-2"
                                fab
                                dark
                                small
                                @click="
                                  ;(formAdd.audiencesCoinStart = ''),
                                    (formAdd.audiencesCoinEnd = '')
                                "
                                color="error"
                              >
                                <v-icon dark>
                                  mdi-minus
                                </v-icon>
                              </v-btn>
                            </v-col> -->
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-text-field
                                   v-model="formAdd.ageStr"
                                  label="อายุเริ่มต้น"
                                  dense
                                  outlined
                                  type="number"
                                  min="0"
                                ></v-text-field>
                              </v-row>
                            </v-col>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-text-field
                                   v-model="formAdd.ageEnd"
                                  dense
                                  outlined
                                  label="อายุสูงสุด"
                                  required
                                  type="number"
                                  min="0"
                                ></v-text-field>
                              </v-row>
                            </v-col>
                            <!-- <v-col cols="2">
                              <v-btn
                                class="mx-2"
                                fab
                                dark
                                small
                                @click="
                                  ;(formAdd.audiencesCoinStart = ''),
                                    (formAdd.audiencesCoinEnd = '')
                                "
                                color="error"
                              >
                                <v-icon dark>
                                  mdi-minus
                                </v-icon>
                              </v-btn>
                            </v-col> -->
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-text-field
                                    v-model="formAdd.audiencesLastUseAll"
                                  label="ไม่ใช้งานมาแล้วกี่วัน"
                                  dense
                                  outlined
                                  required
                                  type="number"
                                  min="0"
                                ></v-text-field>
                              </v-row>
                            </v-col>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-select
                                  :items="ProductExchangeRate"
                                  v-model="formAdd.audiencesExchangeRate"
                                  dense
                                  multiple
                                  outlined
                                  label="ใช้บริการไหน"
                                ></v-select>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions id="v-step-1">
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      dark
                      color="#173053"
                      :disabled="!validAdd"
                      :loading="loadingAdd"
                      @click="addData()"
                    >
                      <v-icon left >mdi-checkbox-marked-circle</v-icon>
                      เพิ่ม
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- Update data -->
          <v-dialog v-model="dialogEdit" persistent max-width="50%">
            <v-card class="text-center">
              <v-form ref="form_update" v-model="validUpdate" lazy-validation>
                <v-card-text>
                  <v-container>
                    <v-col class="text-right">
                      <v-btn
                        small
                        color="#E0E0E0"
                        @click=";(dialogEdit = false),dataReady = true , clearEdit(),this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              ), dataReady = false"
                      >
                        <v-icon color="#173053">mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                    <v-row class="mb-6" justify="center">
                      <v-col md="auto">
                        <v-img
                          class="v_text_edit"
                          :src="require('@/assets/GroupEditTitle.svg')"
                        ></v-img>
                      </v-col>
                    </v-row>
                    <v-row justify="center">
                      <v-col cols="4" class="text-center">
                        <v-card elevation="2" class="mx-auto">
                          <v-container>
                            <v-card-title>เป้าหมายโดยประมาณ</v-card-title>
                            <v-card-text>
                              <v-progress-circular
                                :rotate="360"
                                :size="100"
                                :width="15"
                                :value="valueAdd"
                                color="teal"
                              >
                                {{ valueAdd }} %
                              </v-progress-circular>
                            </v-card-text>
                            <v-card-text>ประมาณ {{ dataAdd }} คน</v-card-text>
                          </v-container>
                        </v-card>
                        <div class="text-center" v-if="Das != 'Das'">
                          <v-btn
                            color="blue-grey"
                            class="ma-2 white--text"
                            @click="getDataEdit()"
                          >
                            Update
                            <v-icon right dark>
                              mdi-cloud-upload
                            </v-icon>
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col cols="8" class="text-center">
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="12">
                              <v-row style="height: 65px">
                                <v-text-field
                                  label="ชื่อกลุ่มเป้าหมาย"
                                  v-model="formUpdate.audiencesName"
                                  :rules="[rules.required]"
                                  :counter="50"
                                  maxlength="50"
                                  dense
                                  outlined
                                  required
                                ></v-text-field>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-select
                                  :items="dataLevel"
                                  v-model="formUpdate.audiencesLevel"
                                  dense
                                  outlined
                                  label="ระดับสมาชิก"
                                ></v-select>
                              </v-row>
                            </v-col>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-select
                                  :items="dataGender"
                                  v-model="formUpdate.audiencesGender"
                                  dense
                                  outlined
                                  label="เพศ"
                                ></v-select>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-text-field
                                   v-model="formUpdate.audiencesCoinStart"
                                  label="เหรียญขั้นต่ำ"
                                  dense
                                  outlined
                                  type="number"
                                  min="0"
                                ></v-text-field>
                              </v-row>
                            </v-col>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-text-field
                                   v-model="formUpdate.audiencesCoinEnd"
                                  dense
                                  outlined
                                  label="เหรียญไม่เกิน"
                                  required
                                  type="number"
                                  min="0"
                                ></v-text-field>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-text-field
                                   v-model="formUpdate.ageStr"
                                  label="อายุเริ่มต้น"
                                  dense
                                  outlined
                                  type="number"
                                  min="0"
                                ></v-text-field>
                              </v-row>
                            </v-col>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-text-field
                                   v-model="formUpdate.ageEnd"
                                  dense
                                  outlined
                                  label="อายุสูงสุด"
                                  required
                                  type="number"
                                  min="0"
                                ></v-text-field>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-text-field
                                    v-model="formUpdate.audiencesLastUseAll"
                                  label="ไม่ใช้งานมาแล้วกี่วัน"
                                  dense
                                  outlined
                                  required
                                  type="number"
                                  min="0"
                                ></v-text-field>
                              </v-row>
                            </v-col>
                            <v-col cols="6">
                              <v-row style="height: 65px">
                                <v-autocomplete
                                  :items="ProductExchangeRate"
                                  v-model="formUpdate.audiencesExchangeRate"
                                  dense
                                  multiple
                                  outlined
                                  label="ใช้บริการไหน"
                                ></v-autocomplete>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col></v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-form>
              <v-card-actions id="v-step-1">
                <v-col id="margin">
                  <v-row justify="center">
                    <v-btn
                      elevation="2"
                      x-large
                      dark
                      color="#173053"
                      :disabled="!validUpdate"
                      :loading="loadingEdit"
                      @click="editData()"
                    >
                      <v-icon left>mdi-checkbox-marked-circle</v-icon>
                      บันทึก
                    </v-btn>
                  </v-row>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- delete -->
          <v-dialog v-model="dialogDelete" persistent max-width="50%">
            <v-card>
              <v-card-title>
                <span class="headline">ลบข้อมูลนี้</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="6">
                      <v-text-field
                        label="Audiences Code"
                        v-model="formUpdate.audiencesCode"
                        readonly
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        label="ชื่อกลุ่มเป้าหมาย"
                        v-model="formUpdate.audiencesName"
                        readonly
                        outlined
                        dense
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  elevation="2"
                  x-large
                  class="btn-color"
                  @click="dialogDelete = false"
                >
                  <v-icon left> mdi-cancel</v-icon>
                  ปิด
                </v-btn>
                <v-btn elevation="2" x-large color="red" @click="deleteData()">
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ลบ
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- dialog Data -->
          <v-dialog v-model="dialogData" persistent max-width="50%">
            <v-card max-width="100%">
              <v-card-actions>
                <v-col id="margin">
                  <v-row justify="center">
                    <v-col cols="12">
                      <v-card elevation="7" v-if="dataReady">
                        <v-card-title>
                          <v-text-field
                            v-model="searchAll3"
                            append-icon="mdi-magnify"
                            label="Search"
                            single-line
                            hide-details
                          ></v-text-field>
                        </v-card-title>
                        <v-card-text>
                          <v-data-table
                            :headers="columns1"
                            :items="formUpdate2"
                            :search="searchAll3"
                            :items-per-page="10"
                          >
                            <template v-slot:[`item.LAST_DATE`]="{ item }">
                              {{ format_dateNotime(item.LAST_DATE) }}
                            </template>
                            <template v-slot:[`item.CREATE_DATE`]="{ item }">
                              {{ format_dateNotime(item.CREATE_DATE) }}
                            </template>
                          </v-data-table>
                        </v-card-text>
                      </v-card>
                      <div v-if="!dataReady" class="text-center">
                        <v-progress-circular
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </div>
                    </v-col>
                  </v-row>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      elevation="2"
                      x-large
                      dark
                      class="btn-color"
                      @click=";(dialogData = false), clearSearch()"
                    >
                      <v-icon left> mdi-cancel</v-icon>
                      ปิด
                    </v-btn>
                  </v-card-actions>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- data tabel -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-title>
                <v-text-field
                  v-model="searchAll2"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-card-text>
                <v-data-table
                  :headers="columns"
                  :items="dataItem"
                  :search="searchAll2"
                  :items-per-page="10"
                >
                  <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_dateNotime(item.CREATE_DATE) }}
                  </template>
                  <template v-slot:[`item.LAST_DATE`]="{ item }">
                    {{ format_dateNotime(item.LAST_DATE) }}
                  </template>
                  <template v-slot:[`item.action`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="btn-color"
                          fab
                          small
                          dark
                          v-bind="attrs"
                          v-on="on"
                          @click.stop="
                            ;(dialogData = true), getDataBordcast(item)
                          "
                        >
                          <v-icon dark> mdi-bullhorn </v-icon>
                        </v-btn>
                      </template>
                      <span>บรอดแคสต์</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          class="btn-color"
                          fab
                          dark
                          id="v-step-2"
                          small
                          @click.stop="getData(item),
                              validate('UPDATE')
                          "
                        >
                          <v-icon dark> mdi-tools </v-icon>
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูล</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="red"
                          dark
                          fab
                          small
                          @click.stop="
                            ;(dialogDelete = true), getDataById(item)
                          "
                        >
                          <v-icon dark> mdi-delete </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูล</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import adminLeftMenu from '../Sidebar.vue' // เมนู
import VuetifyMoney from '../VuetifyMoney.vue'
// import moment from 'moment' // แปลง date
import axios from 'axios' // api
export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney
  },
  data () {
    return {
      path: '/audiences/', // Path Model
      returnLink: '/tool/Audience',
      session: this.$session.getAll(),
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'กลุ่มเป้าหมาย',
          disabled: false,
          href: '/tool/Audience'
        }
      ],
      code: 'AD_', // Generate Code
      valueAdd: 0,
      dataAdd: 0,
      dialogData: false,
      rules: {
        required: value => !!value || 'กรุณากรอก.'
      },
      formAdd: {
        audiencesCode: '',
        audiencesName: '',
        audiencesLevel: '',
        audiencesGender: '',
        audiencesCoinStart: '',
        audiencesCoinEnd: '',
        audiencesExchangeRate: [],
        audiencesLastUseAll: '',
        ageStr: '',
        ageEnd: '',
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: '',
        LAST_USER: ''
      },
      formUpdate2: null,
      formUpdate: {
        id: '',
        audiencesCode: '',
        audiencesName: '',
        audiencesLevel: '',
        audiencesGender: '',
        audiencesCoinStart: '',
        audiencesCoinEnd: '',
        audiencesExchangeRate: '',
        ageStr: '',
        ageEnd: '',
        audiencesVisit: '',
        audiencesReward: '',
        audiencesLastUseAll: '',
        shopId: this.$session.getAll().data.shopId,
        CREATE_USER: '',
        LAST_USER: ''
      },
      columns: [
        { text: 'กลุ่มเป้าหมาย', value: 'audiencesName' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' },
        { text: 'จัดการ', value: 'action', sortable: false, align: 'center' }
      ],
      columns1: [
        { text: 'บอร์ดแคช', value: 'message' },
        { text: 'ประเภท', value: 'module' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        { text: 'วันที่อัพเดท', value: 'LAST_DATE' }
      ],
      // End Menu Config
      dataReady: true,
      menu: false,
      searchAll2: '',
      searchAll3: '',
      dialogAdd: false,
      dialogEdit: false,
      dialogDelete: false,
      validUpdate: true,
      validAdd: true,
      dataLevel: [],
      ProductExchangeRate: [],
      dataGender: [],
      dataPage: [],
      //   loading
      loadingAdd: false,
      loadingEdit: false,
      filterAudience: [],
      dataMember: [],
      startDate: new Date(new Date().getFullYear(), new Date().getMonth(), 2).toISOString().substr(0, 10),
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 30000).toISOString().substr(0, 10),
      arr: [],
      Das: '',
      num: '',
      assddid: ''
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.dataPage()
    await this.getGender()
    // this.dataReady = false
    await this.getDataLevel(
      this.DNS_IP,
      this.session.data.shopId,
      this.returnLink
    )
    await this.getProductExchangeRate(
      this.DNS_IP,
      this.session.data.shopId,
      this.returnLink
    )
    await this.getDataGlobal(
      this.DNS_IP,
      this.path,
      this.session.data.shopId,
      this.returnLink
    )
  },
  methods: {
    async getDataAdd () {
      this.valueAdd = 0
      this.dataAdd = 0
      if ((
        this.formAdd.audiencesLevel +
        this.formAdd.audiencesGender +
        this.formAdd.audiencesCoinStart +
        this.formAdd.audiencesCoinEnd +
        this.formAdd.audiencesExchangeRate +
        this.formAdd.audiencesLastUseAll +
        this.formAdd.ageStr +
        this.formAdd.ageEnd
      ).length === 0) {
      } else {
        if (parseInt(this.formAdd.audiencesCoinStart) > parseInt(this.formAdd.audiencesCoinEnd)) {
          this.$swal(
            'ผิดพลาด',
            'ไม่สามารถกำหนดจำนวน เหรียญขั้นต่ำ ให้มากกว่าจำนวน เหรียญสูงสุด ได้',
            'error'
          )
        } else {
          // alert('aa')
          if (this.formAdd.ageStr > this.formAdd.ageEnd) {
            this.$swal(
              'ผิดพลาด',
              'ไม่สามารถกำหนดจำนวน อายุเริ่มต้น ให้มากกว่าจำนวน อายุสูงสุด ได้',
              'error'
            )
          } else {
            if (this.formAdd.audiencesCoinStart === '') {
              this.formAdd.audiencesCoinStart = 0
            }
            if (this.formAdd.audiencesCoinEnd === '') {
              this.formAdd.audiencesCoinEnd = 0
            }
            if (this.formAdd.ageStr === '') {
              this.formAdd.ageStr = 0
            }
            if (this.formAdd.ageEnd === '') {
              this.formAdd.ageEnd = 0
            }
            if (this.formAdd.audiencesExchangeRate.length === 0) {
              alert('ss')
            } else {
              console.log('dd', this.formAdd.audiencesExchangeRate)
              this.assddid = {
                shopId: this.$session.getAll().data.shopId,
                levelId: this.formAdd.audiencesLevel,
                gender: this.formAdd.audiencesGender,
                coin: this.formAdd.audiencesCoinStart + ' ' + this.formAdd.audiencesCoinEnd,
                ageBetween: this.formAdd.ageStr + ' ' + this.formAdd.ageEnd,
                lastProductExchangeRateId: this.formAdd.audiencesExchangeRate
              }
              var shop = {
                shopId: this.session.data.shopId
              }
              await axios
                .post(this.DNS_IP + '/member/getMember_Audience' + shop)
                .then(res => {
                  this.num = res.data.length
                })
              console.log(this.DNS_IP + '/member/getMember_Audience?shopId=' + this.session.data.shopId +
            '&levelId=' + this.formAdd.audiencesLevel +
            '&gender=' + this.formAdd.audiencesGender +
            '&coin=' + this.formAdd.audiencesCoinStart + ' ' + this.formAdd.audiencesCoinEnd +
            '&ageBetween=' + this.formAdd.ageStr + ' ' + this.formAdd.ageEnd +
            '&lastProductExchangeRateId=' + this.formAdd.audiencesExchangeRate, this.assddid)
              await axios
                .post(
                  this.DNS_IP + '/member/getMember_Audience', this.assddid
                )
                .then(res => {
                  if (res.data.status === false) {
                    this.dataAdd = 0
                    this.valueAdd = 0
                  } else {
                    this.dataAdd = res.data.length
                    this.valueAdd = parseInt(res.data.length * 100 / this.num)
                    console.log('res', res.data)
                  }
                })
            }
          }
        }

        // if (parseInt(this.formAdd.audiencesCoinStart) > parseInt(this.formAdd.audiencesCoinEnd)) {
        //   this.$swal(
        //     'ผิดพลาด',
        //     'ไม่สามารถกำหนดจำนวน เหรียญขั้นต่ำ ให้มากกว่าจำนวน เหรียญไม่เกิน ได้',
        //     'error'
        //   )
        //   this.formAdd.audiencesCoinStart = ''
        // }
        // if () {}
      }
      // new
      // new

      // await axios
      //   .get(
      //     this.DNS_IP + '/member/getMember_Audience?shopId=' + this.session.data.shopId
      //   )
      //   .then(async response => {
      //     if (response.data.status === false) {
      //       this.valueAdd = 0
      //       this.dataAdd = 0
      //     } else {
      //       num = response.data.length
      //       this.valueAdd = 100
      //       this.dataAdd = num
      //       if (this.formAdd.audiencesLastUseAll === 0) {
      //         this.formAdd.audiencesLastUseAll = ''
      //       }
      //       var url = ''
      //       if (
      //         (
      //           this.formAdd.audiencesLevel +
      //           this.formAdd.audiencesGender +
      //           this.formAdd.audiencesCoinStart +
      //           this.formAdd.audiencesCoinEnd +
      //           this.formAdd.audiencesExchangeRate +
      //           this.formAdd.audiencesLastUseAll
      //         ).length === 0
      //       ) {
      //         this.valueAdd = 100
      //         this.dataAdd = num
      //       } else if (
      //         this.formAdd.audiencesGender === 0 &&
      //         this.formAdd.audiencesCoinStart === 0 &&
      //         this.formAdd.audiencesCoinEnd === 0 &&
      //         this.formAdd.audiencesLastUseAll === 0 &&
      //         this.formAdd.audiencesExchangeRate === 0
      //       ) {
      //         if (this.formAdd.audiencesLevel === 'allLevel') {
      //           url =
      //             this.DNS_IP +
      //             '/member/getMember_Audience?shopId=' +
      //             this.session.data.shopId
      //         } else {
      //           url =
      //             this.DNS_IP +
      //             '/member/getMember_Audience?shopId=' +
      //             this.session.data.shopId +
      //             '&levelId=' +
      //             this.formAdd.audiencesLevel
      //         }
      //       } else {
      //         if (
      //           parseInt(this.formAdd.audiencesCoinStart || '0') +
      //             parseInt(this.formAdd.audiencesCoinEnd || '0') >
      //           0
      //         ) {
      //           if (this.formAdd.audiencesCoinStart === '') {
      //             this.formAdd.audiencesCoinStart = 0
      //           }
      //           if (
      //             (parseInt(this.formAdd.audiencesCoinStart || '0') < parseInt(this.formAdd.audiencesCoinEnd || '0')) ||
      //             (parseInt(this.formAdd.audiencesCoinStart || '0') === parseInt(this.formAdd.audiencesCoinEnd || '0'))
      //           ) {
      //             if (this.formAdd.audiencesLevel === 'allLevel') {
      //               url =
      //                 this.DNS_IP +
      //                 '/member/getMember_Audience?shopId=' +
      //                 this.session.data.shopId +
      //                 '&lastUes=' +
      //                 this.formAdd.audiencesLastUseAll +
      //                 '&coin=' +
      //                 this.formAdd.audiencesCoinStart +
      //                 ' ' +
      //                 this.formAdd.audiencesCoinEnd +
      //                 '&lastProductExchangeRateId=' +
      //                 this.formAdd.audiencesExchangeRate +
      //                 '&gender=' +
      //                 this.formAdd.audiencesGender
      //               alert('1')
      //             } else {
      //               url =
      //                 this.DNS_IP +
      //                 '/member/getMember_Audience?shopId=' +
      //                 this.session.data.shopId +
      //                 '&levelId=' +
      //                 this.formAdd.audiencesLevel +
      //                 '&coin=' +
      //                 this.formAdd.audiencesCoinStart +
      //                 ' ' +
      //                 this.formAdd.audiencesCoinEnd +
      //                 '&lastUes=' +
      //                 this.formAdd.audiencesLastUseAll +
      //                 '&lastProductExchangeRateId=' +
      //                 this.formAdd.audiencesExchangeRate +
      //                 '&gender=' +
      //                 this.formAdd.audiencesGender
      //               alert('2')
      //             }
      //           } else {
      //             if (this.formAdd.audiencesLevel === 'allLevel') {
      //               this.$swal(
      //                 'ผิดพลาด',
      //                 'กรุณาตั้ง Coin ไม่เกิน ให้มากกว่า Coin ขั้นต่ำ',
      //                 'error'
      //               )
      //               url =
      //                 this.DNS_IP +
      //                 '/member/getMember_Audience?shopId=' +
      //                 this.session.data.shopId +
      //                 '&lastUes=' +
      //                 this.formAdd.audiencesLastUseAll +
      //                 '&lastProductExchangeRateId=' +
      //                 this.formAdd.audiencesExchangeRate +
      //                 '&gender=' +
      //                 this.formAdd.audiencesGender
      //               alert('3')
      //             } else {
      //               this.$swal(
      //                 'ผิดพลาด',
      //                 'กรุณาตั้ง Coin ไม่เกิน ให้มากกว่า Coin ขั้นต่ำ',
      //                 'error'
      //               )
      //               url =
      //                 this.DNS_IP +
      //                 '/member/getMember_Audience?shopId=' +
      //                 this.session.data.shopId +
      //                 '&levelId=' +
      //                 this.formAdd.audiencesLevel +
      //                 '&lastUes=' +
      //                 this.formAdd.audiencesLastUseAll +
      //                 '&lastProductExchangeRateId=' +
      //                 this.formAdd.audiencesExchangeRate +
      //                 '&gender=' +
      //                 this.formAdd.audiencesGender
      //               alert('4')
      //             }
      //           }
      //         } else {
      //           if (this.formAdd.audiencesLevel === 'allLevel') {
      //             url =
      //               this.DNS_IP +
      //               '/member/getMember_Audience?shopId=' +
      //               this.session.data.shopId +
      //               '&lastUes=' +
      //               this.formAdd.audiencesLastUseAll +
      //               '&lastProductExchangeRateId=' +
      //               this.formAdd.audiencesExchangeRate +
      //                 '&gender=' +
      //                 this.formAdd.audiencesGender
      //             alert('5')
      //           } else {
      //             url =
      //               this.DNS_IP +
      //               '/member/getMember_Audience?shopId=' +
      //               this.session.data.shopId +
      //               '&levelId=' +
      //               this.formAdd.audiencesLevel +
      //               '&lastUes=' +
      //               this.formAdd.audiencesLastUseAll +
      //               '&lastProductExchangeRateId=' +
      //               this.formAdd.audiencesExchangeRate +
      //                 '&gender=' +
      //                 this.formAdd.audiencesGender
      //             alert('6')
      //           }
      //         }
      //         await axios.get(url).then(async res => {
      //           console.log('res', url)
      //           let rs = res.data
      //           console.log('rsrsrsrs', rs)
      //           if (res.data.status === false) {
      //             this.valueAdd = parseInt((0 / num) * 100)
      //             this.dataAdd = 0
      //           } else {
      //             this.valueAdd = parseInt(rs.length * 100 / num)
      //             this.dataAdd = rs.length
      //             console.log('memberCard', rs)
      //           }
      //         })
      //       }
      //     }
      //   })
    },
    async getMember () {
      await axios
        .get(this.DNS_IP + '/member/getMember_Audience?shopId=' + this.session.data.shopId + '&CREATE_DATE=' + '2022-08-01' + ' ' + '2022-09-01')
        .then(res => {
          console.log('res', res)
          if (res.data.status === false) {
            this.dataMember = []
          } else {
            this.dataMember = res.data
            console.log('dataMember', this.dataMember)
          }
        })
    },
    async getDataEdit () {
      this.dialogEdit = true
      this.valueAdd = 0
      this.dataAdd = 0
      if ((
        this.formUpdate.audiencesLevel +
        this.formUpdate.audiencesGender +
        this.formUpdate.audiencesCoinStart +
        this.formUpdate.audiencesCoinEnd +
        this.formUpdate.audiencesExchangeRate +
        this.formUpdate.audiencesLastUseAll +
        this.formUpdate.ageStr +
        this.formUpdate.ageEnd
      ).length === 0) {
      } else {
        if (parseInt(this.formUpdate.audiencesCoinStart) > parseInt(this.formUpdate.audiencesCoinEnd)) {
          this.$swal(
            'ผิดพลาด',
            'ไม่สามารถกำหนดจำนวน เหรียญขั้นต่ำ ให้มากกว่าจำนวน เหรียญสูงสุด ได้',
            'error'
          )
        } else {
          // alert('aa')
          if (this.formUpdate.ageStr > this.formUpdate.ageEnd) {
            this.$swal(
              'ผิดพลาด',
              'ไม่สามารถกำหนดจำนวน อายุเริ่มต้น ให้มากกว่าจำนวน อายุสูงสุด ได้',
              'error'
            )
          } else {
            if (this.formUpdate.audiencesCoinStart === 0) {
              this.formUpdate.audiencesCoinStart = 0
            }
            if (this.formUpdate.audiencesCoinEnd === 0) {
              this.formUpdate.audiencesCoinEnd = 0
            }
            if (this.formUpdate.ageStr === 0) {
              this.formUpdate.ageStr = 0
            }
            if (this.formUpdate.ageEnd === 0) {
              this.formUpdate.ageEnd = 0
            }
            var body = {
              shopId: this.$session.getAll().data.shopId,
              levelId: this.formUpdate.audiencesLevel,
              gender: this.formUpdate.audiencesGender,
              coin: this.formUpdate.audiencesCoinStart + ' ' + this.formUpdate.audiencesCoinEnd,
              ageBetween: this.formUpdate.ageStr + ' ' + this.formUpdate.ageEnd,
              lastProductExchangeRateId: this.formUpdate.audiencesExchangeRate
            }
            var shopEdit = {
              shopId: this.session.data.shopId
            }
            await axios
              .post(this.DNS_IP + '/member/getMember_Audience', shopEdit)
              .then(res => {
                console.log(res.data)
                this.num = res.data.length
              })
            await axios
              .post(
                this.DNS_IP + '/member/getMember_Audience', body
              )
              .then(async res => {
                if (res.data.status === false) {
                  this.dataAdd = 0
                  this.valueAdd = 0
                } else {
                  this.dataAdd = res.data.length
                  this.valueAdd = parseInt(res.data.length * 100 / this.num)
                  console.log(this.valueAdd)
                  console.log('res', res.data)
                }
              })
          }
        }
      }
      // this.valueAdd = 0
      // this.dataAdd = 0
      // var num = 0
      // this.Das = this.formUpdate.audiencesCode.substring(0, 3)
      // if (this.Das === 'Das') {
      //   this.dialogEdit = true
      //   await axios
      //     .get(this.DNS_IP + '/audiencesData/get?shopId=' + this.session.data.shopId + '&AudienceId=' + this.formUpdate.audiencesCode)
      //     .then(res => {
      //       this.arr = res.data
      //       this.arr.map(async el => {
      //         await axios
      //           .get(this.DNS_IP + '/member/getMember_Audience?shopId=' + this.session.data.shopId + '&CREATE_DATE=' + moment(String(el.Start_DATE)).format('YYYY-MM-DD') + ' ' + moment(String(el.End_DATE)).format('YYYY-MM-DD'))
      //           .then(res => {
      //             console.log('res', res)
      //             if (res.data.status === false) {
      //               this.dataMember = []
      //             } else {
      //               this.dataMember = res.data
      //               console.log('dataMember', this.dataMember)
      //             }
      //           })
      //         if (el.AudienceType === 'Branch') {
      //           await axios
      //             .get(this.DNS_IP + '/qrcode/Audience?shopId=' + this.session.data.shopId + '&masBranchID=' + this.formUpdate.audiencesBranch + '&LAST_DATE=' + moment(String(el.Start_DATE)).format('YYYY-MM-DD') + ' ' + moment(String(el.End_DATE)).format('YYYY-MM-DD'))
      //             .then(res => {
      //               let Branch = []
      //               if (res.status === false) {
      //                 Branch = []
      //               } else {
      //                 Branch = res.data
      //                 let a = Branch.filter(val => val.masBranchID.toString() === this.formUpdate.audiencesBranch.toString())
      //                 let serviceFilter = new Set(a.map(({ liffUserId }) => liffUserId))
      //                 let memberFilter = [ ...this.dataMember.filter(({ liffUserId }) => serviceFilter.has(liffUserId)) ]
      //                 memberFilter.forEach(el => {
      //                   this.filterAudience.push(el)
      //                 })
      //               }
      //               this.dataAdd = this.filterAudience.length
      //             })
      //         } else if (el.AudienceType === 'Service') {
      //           await axios
      //             .get(this.DNS_IP + '/qrcode/Audience?shopId=' + this.session.data.shopId + '&productExchangeRateId=' + this.formUpdate.audiencesExchangeRate + '&LAST_DATE=' + moment(String(el.Start_DATE)).format('YYYY-MM-DD') + ' ' + moment(String(el.End_DATE)).format('YYYY-MM-DD'))
      //             .then(res => {
      //               let Service = []
      //               if (res.status === false) {
      //                 Service = []
      //               } else {
      //                 Service = res.data
      //                 let a = Service.filter(val => val.productExchangeRateId.toString() === this.formUpdate.audiencesExchangeRate.toString())
      //                 let serviceFilter = new Set(a.map(({ liffUserId }) => liffUserId))
      //                 let memberFilter = [ ...this.dataMember.filter(({ liffUserId }) => serviceFilter.has(liffUserId)) ]
      //                 memberFilter.forEach(el => {
      //                   this.filterAudience.push(el)
      //                 })
      //               }
      //               this.dataAdd = this.filterAudience.length
      //             })
      //         } else if (el.AudienceType === 'Level') {
      //           await axios
      //             .get(this.DNS_IP + '/member/get?shopId=' + this.session.data.shopId + '&levelId=' + this.formUpdate.audiencesLevel + '&CREATE_DATE=' + moment(String(el.Start_DATE)).format('YYYY-MM-DD') + ' ' + moment(String(el.End_DATE)).format('YYYY-MM-DD') + '&CONDITION_TERM2=True')
      //             .then(res => {
      //               let Level = []
      //               if (res.status === false) {
      //                 Level = []
      //               } else {
      //                 Level = res.data
      //                 let a = Level.filter(val => val.levelId.toString() === this.formUpdate.audiencesLevel.toString())
      //                 let levelFilter = new Set(a.map(({ liffUserId }) => liffUserId))
      //                 let memberFilter = [ ...this.dataMember.filter(({ liffUserId }) => levelFilter.has(liffUserId)) ]
      //                 memberFilter.forEach(el => {
      //                   this.filterAudience.push(el)
      //                 })
      //               }
      //               this.dataAdd = this.filterAudience.length
      //             })
      //         } else if (el.AudienceType === 'Gender') {
      //           await axios
      //             .get(this.DNS_IP + '/member/get?shopId=' + this.session.data.shopId + '&Gender=' + this.formUpdate.audiencesGender + '&CREATE_DATE=' + moment(String(el.Start_DATE)).format('YYYY-MM-DD') + ' ' + moment(String(el.End_DATE)).format('YYYY-MM-DD') + '&CONDITION_TERM2=True')
      //             .then(res => {
      //               let Gender = []
      //               if (res.status === false) {
      //                 Gender = []
      //               } else {
      //                 Gender = res.data
      //                 let a = Gender.filter(val => val.gender === this.formUpdate.audiencesGender)
      //                 let genderFilter = new Set(a.map(({ liffUserId }) => liffUserId))
      //                 let memberFilter = [ ...this.dataMember.filter(({ liffUserId }) => genderFilter.has(liffUserId)) ]
      //                 memberFilter.forEach(el => {
      //                   this.filterAudience.push(el)
      //                 })
      //               }
      //             })
      //           console.log('Gender', this.formUpdate.audiencesGender)
      //         } else if (el.AudienceType === 'Age') {
      //           await axios
      //             .get(this.DNS_IP + '/member/get?shopId=' + this.session.data.shopId + '&title=' + this.formUpdate.audiencesAge + '&CREATE_DATE=' + moment(String(el.Start_DATE)).format('YYYY-MM-DD') + ' ' + moment(String(el.End_DATE)).format('YYYY-MM-DD') + '&CONDITION_TERM2=True')
      //             .then(res => {
      //               let Age = []
      //               if (res.status === false) {
      //                 Age = []
      //               } else {
      //                 Age = res.data
      //                 let a = Age.filter(val => val.title === this.formUpdate.audiencesAge)
      //                 let agederFilter = new Set(a.map(({ liffUserId }) => liffUserId))
      //                 let memberFilter = [ ...this.dataMember.filter(({ liffUserId }) => agederFilter.has(liffUserId)) ]
      //                 memberFilter.forEach(el => {
      //                   this.filterAudience.push(el)
      //                 })
      //               }
      //             })
      //         } else if (el.AudienceType === 'Page') {
      //           await axios
      //             .get(this.DNS_IP + '/TransactionVisitPage/get?shopId=' + this.session.data.shopId + '&page=' + this.formUpdate.audiencesVisit + '&CREATE_DATE=' + moment(String(el.Start_DATE)).format('YYYY-MM-DD') + ' ' + moment(String(el.End_DATE)).format('YYYY-MM-DD'))
      //             .then(res => {
      //               let Page = []
      //               if (res.status === false) {
      //                 Page = []
      //               } else {
      //                 Page = res.data
      //                 console.log('Page', Page)
      //                 let a = Page.filter(val => val.page === this.formUpdate.audiencesVisit)
      //                 console.log('aaaa', a)
      //                 let pageFilter = new Set(a.map(({ CREATE_USER }) => CREATE_USER))
      //                 let memberFilter = [ ...this.dataMember.filter(({ liffUserId }) => pageFilter.has(liffUserId)) ]
      //                 memberFilter.forEach(el => {
      //                   this.filterAudience.push(el)
      //                 })
      //               }
      //             })
      //           console.log('Page', this.filterAudience)
      //         } else {
      //           await axios
      //             .get(this.DNS_IP + '/TransactionVisitPage/get?shopId=' + this.session.data.shopId + '&rewardId=' + this.formUpdate.audiencesReward + '&CREATE_DATE=' + moment(String(el.Start_DATE)).format('YYYY-MM-DD') + ' ' + moment(String(el.End_DATE)).format('YYYY-MM-DD'))
      //             .then(res => {
      //               let rewardId = []
      //               if (res.status === false) {
      //                 rewardId = []
      //               } else {
      //                 rewardId = res.data
      //                 console.log('rewardId', rewardId)
      //                 let a = rewardId.filter(val => val.rewardId === this.formUpdate.audiencesReward)
      //                 console.log('rewardId', a)
      //                 let rewardFilter = new Set(a.map(({ CREATE_USER }) => CREATE_USER))
      //                 let memberFilter = [ ...this.dataMember.filter(({ liffUserId }) => rewardFilter.has(liffUserId)) ]
      //                 memberFilter.forEach(el => {
      //                   this.filterAudience.push(el)
      //                 })
      //               }
      //             })
      //           console.log('Reward', this.formUpdate.audiencesReward)
      //         }
      //         let val = this.filterAudience.map(item => { return item.liffUserId })
      //         console.log('fil', val)
      //         this.dupCounts(val)
      //         console.log('counts', this.dupCounts(val))
      //         let idLiffuser = Object.keys(this.dupCounts(val))
      //         console.log('idLiffuser', idLiffuser)
      //         let data = idLiffuser.map(item => this.dataMember.filter(item2 => (item2.liffUserId === item))).flat()
      //         console.log('ddddd', data)
      //         this.dataAdd = data.length
      //         this.valueAdd = parseInt((data.length / this.dataMember.length) * 100)
      //         this.dataAdd = data.length
      //       })
      //       // console.log('res', res.data)
      //     })
      // } else {
      //   this.dialogEdit = true
      //   await axios
      //     .get(
      //       this.DNS_IP + '/member/getMember_Audience?shopId=' + this.session.data.shopId
      //     )
      //     .then(async response => {
      //       console.log('response555', response.data)
      //       if (response.data.status === false) {
      //         this.valueAdd = 0
      //         this.dataAdd = 0
      //       } else {
      //         num = response.data.length
      //         this.valueAdd = 100
      //         this.dataAdd = num
      //         if (this.formUpdate.audiencesLastUseAll === 0) {
      //           this.formUpdate.audiencesLastUseAll = ''
      //         }
      //         var url = ''
      //         if (
      //           (
      //             this.formUpdate.audiencesLevel +
      //           this.formUpdate.audiencesGender +
      //           this.formUpdate.audiencesCoinStart +
      //           this.formUpdate.audiencesCoinEnd +
      //           this.formUpdate.audiencesExchangeRate +
      //           this.formUpdate.audiencesLastUseAll +
      //           this.formUpdate.audiencesVisit +
      //           this.formUpdate.audiencesReward
      //           ).length === 0
      //         ) {
      //           this.valueAdd = 100
      //           this.dataAdd = num
      //         } else if (
      //           this.formUpdate.audiencesGender === 0 &&
      //         this.formUpdate.audiencesCoinStart === 0 &&
      //         this.formUpdate.audiencesCoinEnd === 0 &&
      //         this.formUpdate.audiencesLastUseAll === 0 &&
      //         this.formUpdate.audiencesExchangeRate === 0 &&
      //         this.formUpdate.audiencesVisit === 0 &&
      //         this.formUpdate.audiencesReward === 0
      //         ) {
      //           if (this.formUpdate.audiencesLevel === 'allLevel') {
      //             url =
      //             this.DNS_IP +
      //             '/member/getMember_Audience?shopId=' +
      //             this.session.data.shopId
      //           } else {
      //             url =
      //             this.DNS_IP +
      //             '/member/getMember_Audience?shopId=' +
      //             this.session.data.shopId +
      //             '&levelId=' +
      //             this.formUpdate.audiencesLevel
      //           }
      //         } else {
      //           if (this.formUpdate.audiencesLastUseAll === null || '0') {
      //             this.formUpdate.audiencesLastUseAll = ''
      //           }
      //           if (this.formUpdate.audiencesVisit === null) {
      //             this.formUpdate.audiencesVisit = ''
      //           }
      //           if (this.formUpdate.audiencesReward === null) {
      //             this.formUpdate.audiencesReward = ''
      //           }
      //           if (this.formUpdate.audiencesBranch === null) {
      //             this.formUpdate.audiencesBranch = ''
      //           }
      //           if (this.formUpdate.audiencesBranch === null) {
      //             this.formUpdate.audiencesBranch = ''
      //           }
      //           if (
      //             parseInt(this.formUpdate.audiencesCoinStart || '0') +
      //             parseInt(this.formUpdate.audiencesCoinEnd || '0') >
      //           0
      //           ) {
      //             if (this.formUpdate.audiencesCoinStart === '') {
      //               this.formUpdate.audiencesCoinStart = 0
      //             }
      //             if (
      //               parseInt(this.formUpdate.audiencesCoinStart || '0') <
      //             parseInt(this.formUpdate.audiencesCoinEnd || '0')
      //             ) {
      //               if (this.formUpdate.audiencesLevel === 'allLevel') {
      //                 url =
      //                 this.DNS_IP +
      //                 '/member/getMember_Audience?shopId=' +
      //                 this.session.data.shopId +
      //                 '&lastUes=' +
      //                 this.formUpdate.audiencesLastUseAll +
      //                 '&coin=' +
      //                 this.formUpdate.audiencesCoinStart +
      //                 ' ' +
      //                 this.formUpdate.audiencesCoinEnd +
      //                 '&lastProductExchangeRateId=' +
      //                 this.formUpdate.audiencesExchangeRate +
      //                 '&gender=' +
      //                 this.formUpdate.audiencesGender +
      //           '&page=' +
      //           this.formUpdate.audiencesVisit +
      //           '&reward=' +
      //           this.formUpdate.audiencesReward
      //               } else {
      //                 url =
      //                 this.DNS_IP +
      //                 '/member/getMember_Audience?shopId=' +
      //                 this.session.data.shopId +
      //                 '&levelId=' +
      //                 this.formUpdate.audiencesLevel +
      //                 '&coin=' +
      //                 this.formUpdate.audiencesCoinStart +
      //                 ' ' +
      //                 this.formUpdate.audiencesCoinEnd +
      //                 '&lastUes=' +
      //                 this.formUpdate.audiencesLastUseAll +
      //                 '&lastProductExchangeRateId=' +
      //                 this.formUpdate.audiencesExchangeRate +
      //                 '&gender=' +
      //                 this.formUpdate.audiencesGender +
      //           '&page=' +
      //           this.formUpdate.audiencesVisit +
      //           '&reward=' +
      //           this.formUpdate.audiencesReward
      //               }
      //             } else {
      //               if (this.formUpdate.audiencesLevel === 'allLevel') {
      //                 this.$swal(
      //                   'ผิดพลาด',
      //                   'กรุณาตั้ง Coin ไม่เกิน ให้มากกว่า Coin ขั้นต่ำ',
      //                   'error'
      //                 )
      //                 url =
      //                 this.DNS_IP +
      //                 '/member/getMember_Audience?shopId=' +
      //                 this.session.data.shopId +
      //                 '&lastUes=' +
      //                 this.formUpdate.audiencesLastUseAll +
      //                 '&lastProductExchangeRateId=' +
      //                 this.formUpdate.audiencesExchangeRate +
      //                 '&gender=' +
      //                 this.formUpdate.audiencesGender +
      //           '&page=' +
      //           this.formUpdate.audiencesVisit +
      //           '&reward=' +
      //           this.formUpdate.audiencesReward
      //               } else {
      //                 this.$swal(
      //                   'ผิดพลาด',
      //                   'กรุณาตั้ง Coin ไม่เกิน ให้มากกว่า Coin ขั้นต่ำ',
      //                   'error'
      //                 )
      //                 url =
      //                 this.DNS_IP +
      //                 '/member/getMember_Audience?shopId=' +
      //                 this.session.data.shopId +
      //                 '&levelId=' +
      //                 this.formUpdate.audiencesLevel +
      //                 '&lastUes=' +
      //                 this.formUpdate.audiencesLastUseAll +
      //                 '&lastProductExchangeRateId=' +
      //                 this.formUpdate.audiencesExchangeRate +
      //                 '&gender=' +
      //                 this.formUpdate.audiencesGender +
      //           '&page=' +
      //           this.formUpdate.audiencesVisit +
      //           '&reward=' +
      //           this.formUpdate.audiencesReward
      //               }
      //             }
      //           } else {
      //             if (this.formUpdate.audiencesLevel === 'allLevel') {
      //               url =
      //               this.DNS_IP +
      //               '/member/getMember_Audience?shopId=' +
      //               this.session.data.shopId +
      //               '&lastUes=' +
      //               this.formUpdate.audiencesLastUseAll +
      //               '&lastProductExchangeRateId=' +
      //               this.formUpdate.audiencesExchangeRate +
      //                 '&gender=' +
      //                 this.formUpdate.audiencesGender +
      //           '&page=' +
      //           this.formUpdate.audiencesVisit +
      //           '&reward=' +
      //           this.formUpdate.audiencesReward
      //             } else {
      //               if (this.formUpdate.audiencesLastUseAll === null) { this.formUpdate.audiencesLastUseAll = '' }
      //               //   alert('5')
      //               url =
      //               this.DNS_IP +
      //               '/member/getMember_Audience?shopId=' +
      //               this.session.data.shopId +
      //               '&levelId=' +
      //               this.formUpdate.audiencesLevel +
      //               '&lastUes=' +
      //               this.formUpdate.audiencesLastUseAll +
      //               '&lastProductExchangeRateId=' +
      //               this.formUpdate.audiencesExchangeRate +
      //                 '&gender=' +
      //                 this.formUpdate.audiencesGender +
      //           '&page=' +
      //           this.formUpdate.audiencesVisit +
      //           '&reward=' +
      //           this.formUpdate.audiencesReward
      //             }
      //           }
      //           await axios.get(url).then(async res => {
      //           //   let data = []
      //             let rs = res.data
      //             //   rs.map(
      //             //     (val, i) => rs.map(e => { return e.liffUserId }).indexOf(val.liffUserId) === i ? data.push(val) : null
      //             //   )
      //             if (res.data.status === false) {
      //               this.valueAdd = parseInt((0 / num) * 100)
      //               this.dataAdd = 0
      //             } else {
      //               console.log('num', num)
      //               this.valueAdd = parseInt((rs.length / num) * 100)
      //               this.dataAdd = rs.length
      //             }
      //           })
      //         }
      //       }
      //     })
      // }
    },
    dupCounts (val) {
      var counts = {}
      val.forEach(function (n) {
        counts[n] = counts[n] || 0
        counts[n]++
      })

      // iterate counts object and remove any that aren't dups
      for (var key in counts) {
        if (counts[key] < this.arr.length) {
          delete counts[key]
        }
      }
      return counts
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async getDataLevel (DNS_IP, shopId, returnLink) {
      // Clear Data ทุกครั้ง
      this.dataLevel = []

      await axios
        .get(
          // eslint-disable-next-line quotes
          DNS_IP + '/level/get?shopId=' + shopId
        )
        .then(async response => {
          console.log('getDataLevel', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            d.text = d.name
            d.value = d.levelId
            this.dataLevel.push(d)
          }
          this.dataLevel.push({ text: 'All Level', value: 'allLevel' })
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + returnLink)
          // this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    },
    async getProductExchangeRate () {
      // Clear Data ทุกครั้ง
      this.ProductExchangeRate = []
      // console.log('getDataTypeGroup')
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/productExchangeRate/' +
            'get?shopId=' +
            this.session.data.shopId
        )
        .then(async response => {
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.value = d.productExchangeRateId
            s.text = d.name
            s.exchangeRate = d.exchangeRate
            d = s
            this.ProductExchangeRate.push(d)
          }
          // console.log('getDataTypeGroup : ', this.UserTypeGroup)
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$router.push('/system/Errorpage?returnLink=' + this.returnLink)
        })
    },
    async getGender () {
      axios
        .get(this.DNS_IP + '/member-gender?shopId=' + this.session.data.shopId)
        .then(respons => {
          let rs = respons.data
          rs.map(item => {
            item.text = item.gender
            item.value = item.gender
            this.dataGender.push(item)
          })
          console.log('dgender', this.dataGender)
        })
    },
    getPage () {
      axios
        .get(this.DNS_IP + '/TransactionVisitPage/get?' + this.session.data.shopId)
        .then(response => {
          let rs = response.data
          rs.map(item => {
            item.text = item.page
            item.value = item.page
            this.dataPage.push(item)
          })
        })
    },
    checkMin () {
      // if (this.formAdd.audiencesCoinStart === '0' || this.formAdd.audiencesCoinStart === '') {
      //   this.formAdd.audiencesCoinEnd = '1'
      // } else {
      if (
        this.formAdd.audiencesCoinEnd === '' ||
        this.formAdd.audiencesCoinEnd === '0'
      ) {
        this.formAdd.audiencesCoinEnd = (
          parseInt(this.formAdd.audiencesCoinStart) + 1000
        ).toString()
      } else if (
        parseInt(this.formAdd.audiencesCoinEnd) >
        parseInt(this.formAdd.audiencesCoinStart)
      ) {
        this.formAdd.audiencesCoinEnd = this.formAdd.audiencesCoinEnd
      } else if (
        parseInt(this.formAdd.audiencesCoinEnd) <=
        parseInt(this.formAdd.audiencesCoinStart)
      ) {
        this.formAdd.audiencesCoinEnd = (
          parseInt(this.formAdd.audiencesCoinStart) + 1000
        ).toString()
      }
      // }
    },
    checkMinUpdate () {
      // if (this.formAdd.audiencesCoinStart === '0' || this.formAdd.audiencesCoinStart === '') {
      //   this.formAdd.audiencesCoinEnd = '1'
      // } else {
      if (
        this.formUpdate.audiencesCoinEnd === '' ||
        this.formUpdate.audiencesCoinEnd === '0'
      ) {
        this.formUpdate.audiencesCoinEnd = (
          parseInt(this.formUpdate.audiencesCoinStart) + 1000
        ).toString()
      } else if (
        parseInt(this.formUpdate.audiencesCoinEnd) >
        parseInt(this.formUpdate.audiencesCoinStart)
      ) {
        this.formUpdate.audiencesCoinEnd = this.formUpdate.audiencesCoinEnd
      } else if (
        parseInt(this.formUpdate.audiencesCoinEnd) <=
        parseInt(this.formUpdate.audiencesCoinStart)
      ) {
        this.formUpdate.audiencesCoinEnd = (
          parseInt(this.formUpdate.audiencesCoinStart) + 1000
        ).toString()
      }
      // }
    },
    addData () {
      this.formAdd.CREATE_USER = this.$session.getAll().data.userName
      this.formAdd.LAST_USER = this.$session.getAll().data.userName
      this.formAdd.audiencesCode = this.code + this.generateCodeGlobal()

      this.dataReady = false
      this.getDataAdd()
      console.log('formAdd', this.formAdd)
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true
          await axios
            .post(
              this.DNS_IP + this.path + 'add',
              this.formAdd
            )
            .then(async response => {
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              this.dialogAdd = false

              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              await this.clearAdd()
              this.loadingAdd = false
            })
          // await this.clearAdd()
        })
    },
    async addData1 () {
      console.log('form', JSON.stringify(this.formAdd))

      if (
        (this.formAdd.audiencesCoinStart + this.formAdd.audiencesCoinEnd)
          .length > 0
      ) {
        if (
          parseInt(this.formAdd.audiencesCoinStart || '0') >
          parseInt(this.formAdd.audiencesCoinEnd || '0')
        ) {
          this.$swal(
            'ผิดพลาด',
            'กรุณาตั้ง Coin ไม่เกิน ให้มากกว่า Coin ขั้นต่ำ',
            'error'
          )
        } else {
          this.submitAdd()
        }
      } else {
        this.submitAdd()
      }
    },
    async submitAdd () {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingAdd = true
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + 'add',
              this.formAdd
            )
            .then(async response => {
              // Debug response
              console.log('addDataGlobal DNS_IP + PATH + "add"', response)
              this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogAdd = false
              // Load Data
              await this.clearAdd()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingAdd = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    clearAdd () {
      this.formAdd.ageStr = ''
      this.formAdd.ageEnd = ''
      this.formAdd.audiencesCode = ''
      this.formAdd.audiencesName = ''
      this.formAdd.audiencesGender = ''
      this.formAdd.audiencesLevel = ''
      this.formAdd.audiencesCoinStart = ''
      this.formAdd.audiencesCoinEnd = ''
      this.formAdd.audiencesExchangeRate = ''
      this.formAdd.audiencesLastUseAll = ''
      this.formAdd.shopId = this.$session.getAll().data.shopId
      this.formAdd.CREATE_USER = ''
      this.formAdd.LAST_USER = ''
      this.valueAdd = 0
      this.dataAdd = 0
    },
    clearEdit () {
      this.filterAudience = []
      this.formUpdate.id = ''
      this.formUpdate.audiencesCode = ''
      this.formUpdate.audiencesName = ''
      this.formUpdate.audiencesLevel = ''
      this.formUpdate.audiencesBranch = ''
      this.formUpdate.audiencesCoinStart = ''
      this.formUpdate.audiencesCoinEnd = ''
      this.formUpdate.audiencesExchangeRate = ''
      this.formUpdate.audiencesLastUseAll = ''
      this.formUpdate.shopId = this.$session.getAll().data.shopId
      this.formUpdate.CREATE_USER = ''
      this.formUpdate.LAST_USER = ''
      this.valueAdd = 0
      this.dataAdd = 0
      console.log('this.formUpdate', this.formUpdate)
    },
    getData (item) {
      console.log(item)
      this.dataReady = false
      this.dialogEdit = true
      axios
        .get(this.DNS_IP + '/audiences/getID?id=' + item.id)
        .then(res => {
          if (res.data.status !== false) {
            console.log('ressssss', typeof res.data.audiencesExchangeRate)
            Object.assign(this.formUpdate, res.data)
            if (this.formUpdate.audiencesExchangeRate) {
              this.formUpdate.audiencesExchangeRate = JSON.parse(this.formUpdate.audiencesExchangeRate)
            }
            console.log(typeof this.formUpdate.audiencesExchangeRate)
            this.getDataEdit()
          }
          console.log('line1884', this.formUpdate)
        })
    },
    async getDataById (item, a) {
      console.log('item', item, a)
      this.dataReady = false
      await this.getDataByIdGlobal(
        this.DNS_IP,
        this.path,
        'id',
        item.id,
        this.returnLink
      )
      console.log('Update', this.formUpdate)
      if (
        this.formUpdate.audiencesLevel !== 'allLevel' &&
        this.formUpdate.audiencesLevel !== ''
      ) {
        this.formUpdate.audiencesLevel = parseInt(
          this.formUpdate.audiencesLevel
        )
      }
      if (this.formUpdate.audiencesExchangeRate !== '') {
        this.formUpdate.audiencesExchangeRate = parseInt(
          this.formUpdate.audiencesExchangeRate
        )
      }
      if (a) {
        await this.getDataEdit()
      }
    },
    async editData () {
      this.dataReady = false
      console.log(this.formUpdate)
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          this.loadingEdit = true
          this.formUpdate.LAST_USER = this.session.data.userName
          var ID = this.formUpdate.id
          delete this.formUpdate['id']
          delete this.formUpdate['CREATE_USER']
          delete this.formUpdate['exchangeName']
          delete this.formUpdate['CREATE_DATE']
          delete this.formUpdate['LAST_DATE']
          delete this.formUpdate['audiencesCode']
          if (this.formUpdate.audiencesExchangeRate === '') {
            this.formUpdate.audiencesExchangeRate = []
          }
          await axios
            .post(
              this.DNS_IP + this.path + 'edit/' + ID,
              this.formUpdate
            )
            .then(async response => {
              // Debug response
              console.log('editDataGlobal DNS_IP + PATH + "edit"', response)

              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              // Close Dialog
              this.dialogEdit = false

              // Load Data
              // await this.reloadData()
              await this.clearEdit()
              await this.getDataGlobal(
                this.DNS_IP,
                this.path,
                this.session.data.shopId,
                this.returnLink
              )
              this.loadingEdit = false
            })
            // eslint-disable-next-line handle-callback-err
            .catch(error => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
              this.$router.push(
                '/system/Errorpage?returnLink=' + this.returnLink
              )
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    async deleteData () {
      this.formUpdate.LAST_USER = this.session.data.userName
      console.log('DELETE PK : ', this.formUpdate.id)
      //
      //
      // สำหรับ ลบข้อมูล
      // ต้องระบุ  Last User ว่าใครเป็นคนลบล่าสุด
      //
      // this.formUpdate.LAST_USER = this.$session.getAll().data.userName
      this.dataReady = false
      this.deleteDataGlobal(
        this.DNS_IP,
        this.path,
        this.formUpdate.id,
        this.session.data.shopId,
        '',
        this.returnLink
      )
    },
    async bordcastName (item) {
      this.$router.push(
        'BroadCast?shopId=' +
          this.$session.getAll().data.shopId +
          '&id=' +
          item.id
      )
    },
    async getDataBordcast (item) {
      this.formUpdate2 = []
      this.dataReady = true
      await axios
        .get(
          this.DNS_IP +
            '/broadcast/get?shopId=' +
            this.session.data.shopId +
            '&audiencesId=' +
            item.id
        )
        .then(response => {
          console.log('item', response.data)
          if (response.data.length > 0) {
            this.formUpdate2 = response.data
          } else {
            this.formUpdate2 = []
          }
        })
    },
    clearSearch () {
      this.searchAll3 = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BroadCast/Audience.vue